import axios, { AxiosResponse } from 'axios';

interface Address {
  address: string;
  district: string;
  city: string;
  state: string;
}

const gateways = [
  {
    url: `https://brasilapi.com.br/api/cep/v2/:zipcode`,
    model: (response: any): Address => {
      const addressResponse = response as {
        cep: string;
        state: string;
        city: string;
        neighborhood: string;
        street: string;
        service: string;
        location: { type: string; coordinates: { longitude: string; latitude: string } };
      };

      return {
        address: addressResponse.street,
        district: addressResponse.neighborhood,
        city: addressResponse.city,
        state: addressResponse.state,
      };
    },
  },
  {
    url: `https://cep.awesomeapi.com.br/json/:zipcode`,
    model: (response: any): Address => {
      const addressResponse = response as {
        cep: string;
        address_type: string;
        address_name: string;
        address: string;
        state: string;
        district: string;
        lat: string;
        lng: string;
        city: string;
        city_ibge: string;
        ddd: string;
      };

      return {
        address: addressResponse.address,
        district: addressResponse.district,
        city: addressResponse.city,
        state: addressResponse.state,
      };
    },
  },
];

// const getAddressByZipcode = async (zipcode: string, gatewayIndex: number = 0): Promise<Address | false> => {
//   const gateway = gateways[gatewayIndex];

//   const getAddress = await fetch(gateway.url.replace(':zipcode', zipcode), {
//     method: 'get',
//   });

//   if (getAddress.status === 200) {
//     const address = await getAddress.json();

//     return gateway.model(address);
//   }

//   if () {
//     return getAddressByZipcode(zipcode, gatewayIndex + 1);
//   }

//   return false;
// };

const getAddressByZipcode = (zipcode: string): Promise<Address> => {
  return new Promise((resolve, reject) => {
    const fetching = async (gatewayIndex: number = 0) => {
      const gateway = gateways[gatewayIndex];

      await axios
        .get(gateway.url.replace(':zipcode', zipcode), {
          method: 'get',
          timeout: 5000,
        })
        .then(({ data }: AxiosResponse<Address>) => {
          resolve(gateway.model(data));
        })
        .catch(() => {
          if (gatewayIndex < gateways.length - 1) {
            fetching(gatewayIndex + 1);
          } else {
            reject();
          }
        });
    };

    fetching();
  });
};

export default getAddressByZipcode;
